"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'tutorial',
  components: {
    Pagination: _Pagination.default
  },
  props: {
    type: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: '教程'
    }
  },
  data: function data() {
    return {
      roles: ['全部', '总后台', '合伙人', '代理商', '业务员', '商家', '用户', '广告'],
      list: [],
      listLoading: true,
      listQuery: {
        start: 1,
        total: 10,
        page_num: 1
      }
    };
  },
  mounted: function mounted(options) {
    this.getList();
  },
  methods: {
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, {
          start: this.listQuery.start - 1,
          article_type: this.type
        }),
        url = 'agentapi/article/index';
      this.$get(url, listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
     * 上架下架
     */
    shelves: function shelves(row) {
      var _this2 = this;
      var agree = row.is_show == 1 ? 0 : 1;
      this.$post('agentapi/article/is_show_switch', {
        id: row.id,
        agree: agree
      }).then(function (res) {
        _this2.$message({
          message: '设置成功',
          type: 'success'
        });
        row.is_show = agree;
      });
    },
    /**
     * 删除文章
     */
    deleteItem: function deleteItem(row) {
      var _this3 = this;
      this.$alert('确定删除此文章吗？', '删除文章', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            _this3.$post('agentapi/article/del', {
              id: row.id
            }).then(function (res) {
              _this3.$message({
                message: '删除成功',
                type: 'success'
              });
              _this3.list.splice(row.index, 1);
            });
          }
        }
      });
    }
  }
};